import { useRef, useEffect, useState } from 'react';
import LineBreaker from './LineBreaker';
import styles from './ExpandableDetails.module.css';

const ExpandableDetails = ({ titleText, expandableText, showLinks = false }) => {
    const [canExpand, setCanExpand] = useState(true);
    const [expanded, setExpanded] = useState(false);
    const textRef = useRef(null);

    const isHorizontallyOverflowing = (textRef) => {
        if (textRef) {
            return textRef.clientWidth < textRef.scrollWidth;
        }
        return false;
    };

    useEffect(() => {
        if (isHorizontallyOverflowing(textRef.current)) {
            setCanExpand(true);
            return;
        }

        setCanExpand(false);
    }, [canExpand]);

    const linksArray = Array.isArray(expandableText) ? expandableText : [expandableText];

    return (
        <div
            className="extraDataWarper"
            onClick={() => {
                if (canExpand) {
                    setExpanded((prev) => !prev);
                }
            }}>
            <div className="extraDataTitle">{titleText}</div>
            <div className={`extraData ${expanded ? 'open' : ''}`} ref={textRef}>
                {showLinks ? (
                    <>
                        {linksArray.filter(linkObj => !!linkObj.link).map((linkObj) => {
                            const desc = linkObj.desc || linkObj.link;
                            return (
                                <a href={linkObj.link} target="_blank" rel="noreferrer" key={linkObj.link}>
                                    {expanded ? <LineBreaker text={desc} /> : `${desc} `}
                                </a>
                            );
                        })}
                    </>
                ) : expanded ? (
                    <LineBreaker text={expandableText} />
                ) : (
                    expandableText
                )}
            </div>
            <div className="extraDataExpander">
                {!canExpand && <i className={`fa fa-angle-up ${styles.transparent}`}></i>}
                {/* Keeping this element here in order to prevent an infinite loop in case the text only overflows with this elem  */}
                {canExpand && expanded && <i className={`fa fa-angle-up`}></i>}
                {canExpand && !expanded && <i className={`fa fa-angle-down`}></i>}
            </div>
        </div>
    );
};

export default ExpandableDetails;
